import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { withTranslation } from "react-i18next";
import Loader from "../../components/Loader";
import Modal from "react-modal";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import withRouter from "../../HOC/withRouter";
import { compose } from "react-recompose";
import TouchPointList from "../../components/TouchPointList";
import { authActionCreators, userActions } from "../../store/actions";
import { promisify } from "../../utils/promisify";
import ProfileHeader from "./ProfileHeader";
import "./styles.scss";

Modal.setAppElement("#root");
class ViewProfile extends React.PureComponent {
  state = {
    isLoading: false,
    open: true,
  };
  handleTouchPoint = touchpointId => {
    if (this.props.location.pathname === "/community") {
      this.props.hideUserProfileModal();
    }
    this.props.navigate(`/touchpoint/${touchpointId}`);
  };

  handleClose = () => {
    if (this.props.location.pathname === "/community") {
      this.props.hideUserProfileModal();
    } else if (this.props.location.state && this.props.location.state.visibility) {
      this.props.navigate("/orga-board", { visibility: this.props.location.state.visibility });
    } else {
      if (window.history?.length > 1) {
        this.props.navigate(-1);
      } else {
        this.props.navigate("/");
      }
    }
  };

  componentDidMount = () => {
    promisify(this.props.getProfileInfo, {
      userId: this.props?.params?.userId ?? this.props.userId,
    })
      .then(res => {
        this.setState({ isLoading: false });
      })
      .catch(err => {
        this.setState({ isLoading: true });
      });
  };

  render() {
    const { isAuthenticated, t, viewProfile, client } = this.props;
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    if (this.state.isLoading) {
      return <Loader color={client?.primaryColor} />;
    }
    return (
      <Modal isOpen={this.state.open} className="brandification-modal-base" onRequestClose={this.handleClose}>
        <div className="page-view-profile ">
          <div className="top">
            <div className="close-touchpoint" onClick={this.handleClose}>
              <FontAwesomeIcon icon={faTimes} />
            </div>
            {viewProfile.user && viewProfile.user.client && (
              <ProfileHeader t={t} user={viewProfile.user} profile={viewProfile} client={client} />
            )}
          </div>
          <div className="p-4">
            <div className="br-section-title mb-3">
              {t("home.TouchpointsFor", {
                username: viewProfile.user && viewProfile.user.name,
                lblTouchPoints: client?.lblTouchPoints,
              })}
              <span>{viewProfile.touchPoints.length}</span>
            </div>
            <TouchPointList list={viewProfile.touchPoints} goToDetails={this.handleTouchPoint} />
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  viewProfile: state.user.profileInfo,
  client: state.client.client,
});

export default compose(
  withRouter,
  connect(mapStateToProps, authActionCreators),
  connect(null, userActions),
)(withTranslation()(ViewProfile));
